import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ChangePassword } from '../../interfaces/change-password.interface';
import { AuthenticationHttpService } from '../../services/authentication-http.service';
import { TranslocoService } from '@ngneat/transloco';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../state/authentication.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm!: FormGroup;

  constructor(public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private form: FormBuilder,
    private authenticationHttpService: AuthenticationHttpService,
    private toastrService: ToastrService,
    private translocoService: TranslocoService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.changePasswordForm = this.form.group({
      currentPassword: [null, [Validators.required]],
      passwordGroup: this.form.group({
        newPassword: [null, [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]],
        confirmPassword: [null, [Validators.required]]
      }, { validator: this.matchPassword })
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {
      const emailControls = (this.changePasswordForm.get('passwordGroup') as FormGroup).controls;

      this.authenticationHttpService.changePassword({
        currentPassword: this.changePasswordForm.get('currentPassword')?.value,
        newPassword: emailControls['newPassword'].value
      } as ChangePassword).subscribe(
        (result: any) => {
          if (result) {
            this.toastrService.success(this.translocoService.translate('changePassword.Submit Success'));
            this.dialogRef.close();
            this.authenticationService.logout();
          } else {
            this.toastrService.info(this.translocoService.translate('changePassword.Submit Error'));
          }
        },
        (err: any) => console.log(err)
      );
    }
  }

  matchPassword(group: AbstractControl): { [key: string]: any } | null {
    const newPasswordControl = group.get('newPassword');
    const confirmPasswordControl = group.get('confirmPassword');

    if (
      confirmPasswordControl == null ||
      newPasswordControl == null ||
      confirmPasswordControl.value === newPasswordControl.value ||
      confirmPasswordControl.pristine
    ) {
      return null;
    } else {
      return { passwordMismatch: true };
    }
  }

}
